import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ScoutingMap, HeatmapOrchard, InspectionPoint } from '../common/ScoutingMap';
import { FreshnessLegend } from './FreshnessLegend';
import { FreshnessThresholds } from '../../utils/scoutingUtils';
import './ScoutingDashboard.css';

interface Props {
  heatmapOrchards: HeatmapOrchard[];
  points: InspectionPoint[];
  thresholds: FreshnessThresholds;
  canViewRecords: boolean;
}

export const ScoutingMapBand: React.FC<Props> = ({ heatmapOrchards, points, thresholds, canViewRecords }) => {
  const { t } = useTranslation();
  const [colorBy, setColorBy] = useState<'pest' | 'scouter'>('pest');
  const [showLegend, setShowLegend] = useState(false);
  const hasOrchards = heatmapOrchards.length > 0;

  return (
    <div className="scouting-map-band" data-testid="scouting-map-band">
      <div className="scouting-map-band__toolbar">
        <button
          type="button"
          className="pat-btn pat-btn--subtle"
          onClick={() => setColorBy(v => v === 'pest' ? 'scouter' : 'pest')}
          aria-pressed={colorBy === 'scouter'}
          disabled={!hasOrchards}
        >
          {colorBy === 'pest' ? t('dashboard.byScouter') : t('dashboard.byPest')}
        </button>
        <button
          type="button"
          className="pat-btn pat-btn--subtle"
          onClick={() => setShowLegend(v => !v)}
          aria-pressed={showLegend}
          disabled={!hasOrchards}
        >
          {showLegend ? t('dashboard.hideLegend') : t('dashboard.showLegend')}
        </button>
      </div>
      {showLegend && <FreshnessLegend thresholds={thresholds} />}
      <div className="scouting-map-band__map">
        <ScoutingMap
          points={points}
          orchard={null}
          heatmapOrchards={heatmapOrchards}
          colorBy={colorBy}
          thresholds={thresholds}
          canViewRecords={canViewRecords}
        />
      </div>
    </div>
  );
};
